import { connect } from 'react-redux';
import { nucleusConstants } from '@lifesize/nucleus';
import ContactIcon from 'components/Contacts/ContactIcon';
import cancelIcon from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import manualDialIcon from '@lifesize/ux-assets/vectors/svgIcons/hashtag.svg';
import peopleIcon from '@lifesize/ux-assets/vectors/svgIcons/people.svg';
import otmIcon from '@lifesize/ux-assets/vectors/svgIcons/hourglass.svg';
import personIcon from '@lifesize/ux-assets/vectors/svgIcons/person.svg';
import roomSystemIcon from '@lifesize/ux-assets/vectors/svgIcons/room-system.svg';

function mapStateToProps(state, ownProps) {
  let presence = null;
  let icon = personIcon;
  const contact = ownProps.contact;

  if (contact) {
    if (contact.isRoomSystem) {
      icon = roomSystemIcon;
      switch (contact.presence) {
        case 'AVAILABLE':
          presence = 'contactPresenceAvailable';
          break;
        default:
          presence = 'contactPresenceNotAvailable';
      }
    } else if (contact.isNullContact) {
      icon = cancelIcon;
    } else if (contact.isMeeting) {
      if (contact.meetingType === nucleusConstants.MEETING_TYPE_ONE_TIME) {
        icon = otmIcon;
      } else {
        icon = peopleIcon;
      }
      presence = 'contactPresenceAvailable';
    } else if (contact.isManual) {
      icon = manualDialIcon;
    } else if (contact.isCreateOneTime) {
      icon = otmIcon;
      presence = null;
    } else {
      icon = personIcon;
      switch (contact.presence) {
        case 'AVAILABLE':
          presence = 'contactPresenceAvailable';
          break;
        case 'NOT_AVAILABLE':
          presence = 'contactPresenceNotAvailable';
          break;
        default:
          presence = 'contactPresenceDoNotDisturb';
      }
    }
  }

  return {
    icon,
    presence
  };
}

export default connect(mapStateToProps)(ContactIcon);
